import { Table } from "../../../features/Table";
import {
  type D1Portfolio,
  porfolios_columns,
  columnVisibilityInit,
} from "./columns";
import { type FilterD1PortfoliosSchema, FilterD1Portfolios } from "./filter";
import { Clients } from "@/lib/clients";

import { Tables } from "@/gen/tableNames/tables";

export const D1PortfoliosTable = () => {
  return (
    <Table<D1Portfolio, FilterD1PortfoliosSchema>
      label="Portfolios"
      client={Clients.D1}
      table_name={Tables.D1_PORTFOLIOS}
      columns={porfolios_columns}
      columnVisibilityInit={columnVisibilityInit}
      filter={<FilterD1Portfolios />}
      actions={[
        {
          label: "actions.new",
          route: `${Clients.D1}/${Tables.D1_PORTFOLIOS}/new`,
        },
      ]}
    />
  );
};
